import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useEditSurveyTemplateDialogStyles = makeStyles({
  dialogSurface: {
    maxHeight: "85vh",
  },
  dialogContent: {
    maxHeight: "60vh",
    overflowY: "auto",
  },
  dialogField: {
    marginBottom: designTokens.spacing[3],
  },
  errorAlert: {
    color: projectIqTokens.rust,
    fontSize: designTokens.fontSize.sm,
    marginBottom: designTokens.spacing[2],
  },
});
